import axios from 'axios';
import {
  checkTokenHeaders,
  checkMachineToken
} from './apiHelper';
const config = require('../../config.json')
const baseUrlApi = `${config.baseUrl}/api`;
import Router from '../router'


export const req = (token = null) => {
  const headers = checkMachineToken();
  return new Promise((res, rej) => {
    if (token) {
      checkTokenHeaders(token, headers)
        .then(headers => {
          res(headers)
        })
        .catch(() => {
          Router.push({
            name: "pageLogin",
            params: {
              err: 'err401'
            }
          })
        })
    } else {
      res(headers)
    }
  }).catch(() => {
    Router.push({
      name: "pageLogin"
    })
  })
}
export const Request = axios.create({
  baseURL: baseUrlApi,
  headers: {
    'Content-Type': 'application/json',
  },

})

let route = false;
Request.interceptors.response.use(undefined, function (error) {
  if (error.response.status === 401) {
    if (!route && Router.currentRoute.name !== 'pageLogin') {
      route = true;
      Router.push({
        name: "pageLogin",
        params: {
          err: 'err401'
        }
      }).then(() => route = false)
    }
  }
  return Promise.reject(error);
});
